<template>
    <div class="modal-overlay">
        <div class="modal-card">

            <div class="modal-header">
                <h3>Assinaturas vinculadas</h3>
            </div>

            <div class="modal-body">

                <div
                    v-if="msgAlerta"
                    class="info-alert row-space"
                >
                    {{ msgAlerta }}
                </div>

                <div
                    v-else-if="lsDados.length === 0"
                    class="info-empty"
                >
                    Nenhuma assinatura encontrada para este registro.
                </div>

                <div
                    v-else
                    class="table-wrapper"
                >
                    <table>
                        <thead>
                            <tr>
                                <th>Usuário</th>
                                <th>Perfil</th>
                                <th>Status</th>
                                <th>Data/Hora</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr
                                v-for="item in lsDados"
                                :key="item.id"
                            >
                                <td>
                                    <strong>{{ item.nmusuarioass }}</strong>
                                </td>

                                <td>
                                    {{ item.nmperfil }}
                                </td>

                                <td>
                                    <span
                                        class="status-pill"
                                        :class="statusClass(item.nmstatus)"
                                    >
                                        {{ item.nmstatus }}
                                    </span>
                                </td>

                                <td>
                                    {{ Funcoes.formatDateTimeFromJson(item.ass_dhassinatura) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

            <div class="modal-footer">
                <button
                    class="btn-small"
                    @click="closeModal"
                >
                    Fechar
                </button>
            </div>

        </div>
    </div>
</template>


<script setup>
import { ref, onMounted } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';

const props = defineProps({
    refTable: { type: String, required: true },
    refId: { type: Number, required: true },
});

const emit = defineEmits(['close']);

const lsDados = ref([]);
const msgAlerta = ref(null);

async function lerDados() {
    try {
        msgAlerta.value = null;

        const req = await Api.genericPost('/dados/assinatura/pendencia', {
            idep: globalStore.idep,
            strparam1: props.refTable,
            idreferencia: props.refId
        });

        lsDados.value = req || [];
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }
}

function closeModal() {
    emit('close');
}

function statusClass(status) {
    const s = String(status || '').toUpperCase();

    if (s.includes('ASSINADO')) return 'status-ok';
    if (s.includes('PENDENTE')) return 'status-pendente';
    if (s.includes('RECUSADO') || s.includes('CANCELADO')) return 'status-erro';

    return 'status-neutro';
}

onMounted(lerDados);
</script>

<style scoped>
.modal-card {
    background: #fff;
    width: min(900px, 95vw);
    max-height: 90vh;

    border-radius: 8px;
    border: 2px solid #aaa;

    display: flex;
    flex-direction: column;
}

.modal-header {
    padding: 10px 15px;
    border-bottom: 2px solid #ccc;
    background: #f3f3f3;
}

.modal-header h3 {
    margin: 0;
}

.modal-body {
    padding: 15px;
    overflow-y: auto;
    flex: 1;
}

.modal-footer {
    padding: 10px 15px;
    border-top: 2px solid #ccc;
    display: flex;
    justify-content: flex-end;
}

.status-pill {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: bold;
}

.status-ok {
    background: #dff5e1;
    color: #1d6b28;
}

.status-pendente {
    background: #fff1c9;
    color: #8a6500;
}

.status-erro {
    background: #ffd6d6;
    color: #9e0000;
}

.status-neutro {
    background: #ececec;
    color: #555;
}
</style>